import React, { useState } from "react";
import "./DonationDetails.css";
import DonationSectionw from '../components/DonationSectionw';
import DonationSectionAnotherw from './DonationSectionAnotherw';
import AboutLegalForDonate from '../pages/AboutLegalForDonate';


const donationData = [
  {
    title: "ISLAMIC RESEARCH CENTRE EDUCATION AND WELFARE TRUST",
    accountNo: "33809625114",
    ifsc: "SBIN0001716",
    bank: "STATE BANK OF INDIA",
    branchCode: "1716",
    branch: "Kranti Chowk, Chhatrapati Sambhajinagar (Aurangabad)",
    type: "Current Account",
    micr: "431002002",
    color: "#e74c3c",
    icon: "🏦"
  },
  {
    title: "AL KITAB EDUCATION AND WELFARE SOCIETY",
    accountNo: "07131450001360",
    ifsc: "HDFC0000713",
    bank: "HDFC Bank",
    branchCode: "713",
    branch: "IHM Branch, Chhatrapati Sambhajinagar (Aurangabad)",
    type: "Saving Account",
    micr: "431240004",
    color: "#2ecc71",
    icon: "💳"
  },
  {
    title: "ILM FOUNDATION EDUCATION & WELFARE WAKF",
    accountNo: "07131450000939",
    ifsc: "HDFC0000713",
    bank: "HDFC Bank",
    branchCode: "713",
    branch: "IHM Branch, Chhatrapati Sambhajinagar (Aurangabad)",
    type: "Current Account",
    micr: "431240004",
    color: "#3498db",
    icon: "📘"
  },
];

const DonationDetailsAnother = () => {
  const [copiedField, setCopiedField] = useState(null);
  const [toastVisible, setToastVisible] = useState(false);
  const [toastMessage, setToastMessage] = useState("");

  const copyToClipboard = (text, fieldName, fieldLabel) => {
    navigator.clipboard.writeText(text);
    setCopiedField(fieldName);
    setToastMessage(`"${fieldLabel}" copied to clipboard!`);
    setToastVisible(true);
    
    setTimeout(() => {
      setCopiedField(null);
    }, 2000);
    
    setTimeout(() => {
      setToastVisible(false);
    }, 3000);
  };

  return (
    <>
    <DonationSectionAnotherw />
      <DonationSectionw />
      <div className="donation-containerr">
        {/* Toast Notification */}
        {toastVisible && (
          <div className="copy-toast">
            <div className="toast-content">
              <span className="toast-icon">✓</span>
              <span className="toast-message">{toastMessage}</span>
            </div>
          </div>
        )}

        <div className="donation-header">
          <h2 className="donation-title">Support Our Cause</h2>
          <p className="donation-subtitle">Your donation makes a difference</p>
          <div className="header-decoration"></div>
        </div>

        <div className="donation-contact-card">
          <div className="contact-icon">📞</div>
          <div className="contact-details">
            <h3>Need Assistance?</h3>
            <p>FOR DETAILS OR CONFIRMATION OF DONATION PLEASE CONTACT</p>
            <div className="contact-methods">
              <div className="contact-method">
                <span className="method-icon">📞</span>
                <a href="tel:+918055557738">+91-8055557738</a>
              </div>
              <div className="contact-method">
                <span className="method-icon">💬</span>
                <a href="https://wa.me/918055557738" target="_blank" rel="noreferrer">
                  WhatsApp
                </a>
              </div>
              <div className="contact-method">
                <span className="method-icon">✉️</span>
                <a href="mailto:donate@irc-india.com">donate@irc-india.com</a>
              </div>
            </div>
          </div>
        </div>

        <div className="donation-grid">
          {donationData.map((item, idx) => (
            <div key={idx} className="donation-cardd" style={{ "--accent-color": item.color }}>
              <div className="card-header">
                <span className="bank-icon">{item.icon}</span>
                <h3>{item.title}</h3>
              </div>
              
              <div className="account-details">
                <div className="detail-row">
                  <span className="detail-label">Account No:</span>
                  <div className="detail-value">
                    <span>{item.accountNo}</span>
                    <button 
                      className={`copy-btn ${copiedField === `account-${idx}` ? 'copied' : ''}`}
                      onClick={() => copyToClipboard(item.accountNo, `account-${idx}`, "Account Number")}
                      aria-label="Copy account number"
                    >
                      {copiedField === `account-${idx}` ? '✓ Copied' : '📋 Copy'}
                    </button>
                  </div>
                </div>
                
                <div className="detail-row">
                  <span className="detail-label">IFSC Code:</span>
                  <div className="detail-value">
                    <span>{item.ifsc}</span>
                    <button 
                      className={`copy-btn ${copiedField === `ifsc-${idx}` ? 'copied' : ''}`}
                      onClick={() => copyToClipboard(item.ifsc, `ifsc-${idx}`, "IFSC Code")}
                      aria-label="Copy IFSC code"
                    >
                      {copiedField === `ifsc-${idx}` ? '✓ Copied' : '📋 Copy'}
                    </button>
                  </div>
                </div>
                
                <div className="detail-row">
                  <span className="detail-label">Bank Name:</span>
                  <span className="detail-value">{item.bank}</span>
                </div>
                
                <div className="detail-row">
                  <span className="detail-label">Branch:</span>
                  <span className="detail-value">{item.branch}</span>
                </div>
                
                <div className="detail-row">
                  <span className="detail-label">Account Type:</span>
                  <span className="detail-value">{item.type}</span>
                </div>
                
                <div className="detail-row">
                  <span className="detail-label">MICR Code:</span>
                  <div className="detail-value">
                    <span>{item.micr}</span>
                    <button 
                      className={`copy-btn ${copiedField === `micr-${idx}` ? 'copied' : ''}`}
                      onClick={() => copyToClipboard(item.micr, `micr-${idx}`, "MICR Code")}
                      aria-label="Copy MICR code"
                    >
                      {copiedField === `micr-${idx}` ? '✓ Copied' : '📋 Copy'}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="donation-actions">
          <button className="back-btn" onClick={() => window.history.back()}>
            <span className="btn-icon">←</span> BACK
          </button>
        </div>

        <div className="donation-footer">
          <p>All donations are tax exempted under 80G of Income Tax Act</p>
        </div>
      <AboutLegalForDonate />

      </div>
    </>
  );
};

export default DonationDetailsAnother;